import React, { useContext, useEffect, useState } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_AS_TYPE } from '@motorway/mw-highway-code/enums';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { VERIFICATION_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsDocumentVerification';
import { isDesktopDevice } from 'Utilities/devices';
import { EARLY_DOCS_START_PAGE, INCODE_EARLY_DOCS_SLUG } from 'Utilities/routing';

import { useOneTimeToken } from '../../hooks/useOneTimeToken';
import LocalTexts from '../../UploadDocuments.texts.json';
import { INCODE_VERIFICATION_SELLER_TYPE, useIncodeVerificationDocuments } from '../IncodeSDKPage/hooks/useIncodeVerificationDocuments';

import { UploadDocumentsVerificationWrapper } from './UploadDocumentsVerificationWrapper';

const LocalT = new MDText(LocalTexts.uploadDocumentsVerification);

export const UploadDocumentsVerificationEarlyDocs = () => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSafeDesktopDevice, setIsSafeDesktopDevice] = useState(false);

  const { token } = useOneTimeToken();

  const { data, isLoading } = useIncodeVerificationDocuments({
    enquiryId: vehicle?.enquiry?.dpEnquiryId,
    verificationType: INCODE_VERIFICATION_SELLER_TYPE,
  });

  useEffect(() => {
    VERIFICATION_ANALYTICS_EVENTS.LOAD_HANDOFF();
    setIsSafeDesktopDevice(isDesktopDevice());
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const label = (data?.isDocsEarly && data?.completedSteps?.length)
    ? LocalT.translate('finishVerification') as string
    : LocalT.translate('startVerification') as string;

  const renderButton = () => {
    const commonProps = {
      disabled: isLoading,
      fullWidth: true,
      label,
      loading: isLoading,
    };

    if (isSafeDesktopDevice) {
      return (
        <Button
          {...commonProps}
          as={BUTTON_AS_TYPE.BUTTON}
          onClick={() => {
            setIsModalOpen(true);
            VERIFICATION_ANALYTICS_EVENTS.INCODE_QR_MODAL_OPEN({
              label,
              url: EARLY_DOCS_START_PAGE,
            });
          }}
        />
      );
    }

    return (
      <Button
        {...commonProps}
        as={BUTTON_AS_TYPE.ANCHOR}
        href={`/${vehicle.vrm}${INCODE_EARLY_DOCS_SLUG}`}
        onClick={VERIFICATION_ANALYTICS_EVENTS.CONTINUE_VERIFICATION}
      />
    );
  };

  return (
    <UploadDocumentsVerificationWrapper
      closeModal={closeModal}
      isModalOpen={isModalOpen}
      renderButton={renderButton}
      slug={INCODE_EARLY_DOCS_SLUG}
      token={token}
      vehicle={vehicle}
    />
  );
};
